import {useReposAnalytics} from '@github-ui/code-view-shared/hooks/use-repos-analytics'
import {GlobalCommands} from '@github-ui/ui-commands'
import type React from 'react'

export function FindFilesShortcut({
  inputRef,
  onFindFilesShortcut,
}: {
  inputRef: React.RefObject<HTMLInputElement | null> | null
  onFindFilesShortcut?: () => void
  textAreaId: string
}) {
  const {sendRepoKeyDownEvent} = useReposAnalytics()

  return (
    <GlobalCommands
      commands={{
        'code-view:find-files': () => {
          onFindFilesShortcut?.()
          inputRef?.current?.focus()
          sendRepoKeyDownEvent('GO_TO_FILE')
        },
      }}
    />
  )
}
